import {
  OwnershipType,
  OwnershipTypeCreateCommand,
  OwnershipTypeCreatedEvent,
  OwnershipTypeDeleteCommand,
  OwnershipTypeDeletedEvent,
  OwnershipTypeId,
  OwnershipTypePageQuery,
  OwnershipTypeUpdateCommand,
  OwnershipTypeUpdatedEvent
} from "../model/OwnershipType";
import {config} from "../../../config";
import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {firstPage, PageQuery, PageResult, toPagination} from "@tracabois/utils";
import {useState} from "react";
import {authQuery} from "../../../utils/authQuery";

export const OwnershipTypeApi = createApi({
  reducerPath: 'ownershipTypeApi',
  baseQuery: authQuery({baseUrl: config.baseUrl}),
  tagTypes: ['OwnershipType'],
  endpoints: (builder) => ({
    getOwnershipTypeById: builder.query<OwnershipType, OwnershipTypeId>({
      query: (id: OwnershipTypeId) => ({
        url: `ownershipTypeGet`,
        method: 'POST',
        body: {id: id}
      }),
    }),
    ownershipTypePage: builder.query<PageResult<OwnershipType>, OwnershipTypePageQuery>({
      query: (page: OwnershipTypePageQuery) => ({
        url: `ownershipTypePage`,
        method: 'POST',
        body: page
      }),
      transformResponse: (response: PageResult<OwnershipType>[]) => response[0],
      providesTags: ['OwnershipType'],
    }),
    ownershipTypeCreate: builder.mutation<OwnershipTypeCreatedEvent, OwnershipTypeCreateCommand>({
      query: (cmd: OwnershipTypeCreateCommand) => ({
        url: `ownershipTypeCreate`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: OwnershipTypeCreatedEvent[]) => response[0],
      invalidatesTags: ['OwnershipType'],
    }),
    ownershipTypeUpdate: builder.mutation<OwnershipTypeUpdatedEvent, OwnershipTypeUpdateCommand>({
      query: (cmd: OwnershipTypeUpdateCommand) => ({
        url: `ownershipTypeUpdate`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: OwnershipTypeUpdatedEvent[]) => response[0],
      invalidatesTags: ['OwnershipType'],
    }),
    ownershipTypeDelete: builder.mutation<OwnershipTypeDeletedEvent, OwnershipTypeDeleteCommand>({
      query: (cmd: OwnershipType) => ({
        url: `ownershipTypeDelete`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: OwnershipTypeDeletedEvent[]) => response[0],
      invalidatesTags: ['OwnershipType'],
    }),
  }),
})

export const {
  useGetOwnershipTypeByIdQuery, useOwnershipTypePageQuery,
  useOwnershipTypeCreateMutation, useOwnershipTypeUpdateMutation, useOwnershipTypeDeleteMutation
} = OwnershipTypeApi


export const useOwnershipTypeAllQuery = () => {
  const {data, error, isLoading, refetch} = OwnershipTypeApi.useOwnershipTypePageQuery({})
  const [pageQuery, setPageQuery] = useState<PageQuery>({
    pagination: firstPage
  })
  let sortedData =  [...data?.items ?? []]
  if(pageQuery.search) {
    sortedData = sortedData.filter((item) => {
      return item.name.toLowerCase().includes(pageQuery.search?.toLowerCase() ?? "")
    })
  }
  const page = toPagination(sortedData, pageQuery.pagination)

  return {data: page, error, isLoading, refetch, setPageQuery}
}
